import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const OccasionSelection: React.FC = () => {
  const navigate = useNavigate();
  const { schoolId } = useParams();
  const [selectedTab, setSelectedTab] = useState<'individuals' | 'businesses'>('individuals');

  const individualOccasions = [
    { id: 'birthday', name: 'Birthday', description: 'Perfect for birthday celebrations', price: 50 },
    { id: 'graduation', name: 'Graduation', description: 'Celebrate academic achievements', price: 50 },
    { id: 'christmas', name: 'Christmas', description: 'Holiday season greetings', price: 50 },
    { id: 'valentines', name: "Valentine's Day", description: 'Show your love and appreciation', price: 50 },
    { id: 'anniversary', name: 'Anniversary', description: 'Celebrate special milestones', price: 50 },
    { id: 'custom', name: 'Custom', description: 'Any special occasion', price: 50 },
  ];
  const businessOccasions = [
    { id: 'holiday', name: 'Holiday', description: 'Seasonal and holiday business promotions', price: 500 },
    { id: 'event', name: 'Event', description: 'Promote a business event or activation', price: 500 },
    { id: 'opening', name: 'Opening', description: 'Celebrate your new business opening', price: 500 },
  ];

  const occasions = selectedTab === 'individuals' ? individualOccasions : businessOccasions;
  const pageCopy = useMemo(
    () =>
      selectedTab === 'individuals'
        ? {
            title: 'Personal Video Occasions',
            subtitle: 'Pick the perfect moment to surprise someone with a personalized performance.',
          }
        : {
            title: 'Business Video Campaigns',
            subtitle: 'Drive attention and sales with branded videos for your next promotion, event, or launch.',
          },
    [selectedTab]
  );

  const handleOccasionSelect = (occasionId: string) => {
    navigate(`/schools/${schoolId}/occasions/${occasionId}/order`);
  };

  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-white mb-4">{pageCopy.title}</h1>
          <p className="text-lg text-gray-300">{pageCopy.subtitle}</p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="inline-flex rounded-lg border-2 border-black bg-sky p-1">
            <button
              type="button"
              className={`px-5 py-2 rounded-md font-semibold transition-colors duration-200 ${
                selectedTab === 'individuals' ? 'bg-black text-white' : 'text-black hover:bg-black/10'
              }`}
              onClick={() => setSelectedTab('individuals')}
            >
              Individuals
            </button>
            <button
              type="button"
              className={`px-5 py-2 rounded-md font-semibold transition-colors duration-200 ${
                selectedTab === 'businesses' ? 'bg-black text-white' : 'text-black hover:bg-black/10'
              }`}
              onClick={() => setSelectedTab('businesses')}
            >
              Businesses
            </button>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {occasions.map((occasion) => (
            <div 
              key={occasion.id}
              className="card-hover cursor-pointer bg-sky border-2 border-black p-6 hover:border-white transition-colors duration-200"
              onClick={() => handleOccasionSelect(occasion.id)}
            >
              <h3 className="text-xl font-semibold text-black mb-2">{occasion.name}</h3>
              <p className="text-white mb-4">{occasion.description}</p>
              <p className="text-black font-semibold">${occasion.price}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OccasionSelection; 